// Shared hashing & Meta Advanced Matching normalization.
// Imported by both the Worker and the browser beacon — keep platform-agnostic.

export type AMField =
  | 'em' | 'ph' | 'fn' | 'ln'
  | 'ct' | 'st' | 'zp' | 'country'
  | 'db' | 'ge' | 'external_id';

export type AMInputs = Partial<Record<AMField, string>>;

export const META_NORMALIZERS: Record<AMField, (v: string) => string> = {
  em: (v) => v.trim().toLowerCase(),
  ph: (v) => v.replace(/\D/g, '').replace(/^0+/, ''),
  fn: (v) => v.trim().toLowerCase().replace(/[^\p{L}\p{N}]/gu, ''),
  ln: (v) => v.trim().toLowerCase().replace(/[^\p{L}\p{N}]/gu, ''),
  ct: (v) => v.trim().toLowerCase().replace(/\s+/g, ''),
  st: (v) => v.trim().toLowerCase().slice(0, 2),
  zp: (v) => v.trim().toLowerCase().slice(0, 5),
  country: (v) => v.trim().toLowerCase().slice(0, 2),
  db: (v) => v.replace(/\D/g, '').slice(0, 8),
  ge: (v) => v.trim().toLowerCase().slice(0, 1),
  external_id: (v) => v.trim().toLowerCase(),
};

export function normalizeAM(field: AMField, value: string): string {
  return META_NORMALIZERS[field](value);
}

export async function sha256Hex(input: string): Promise<string> {
  const buf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(input));
  return [...new Uint8Array(buf)].map(b => b.toString(16).padStart(2, '0')).join('');
}

export async function hashAM(field: AMField, value: string): Promise<string> {
  return sha256Hex(normalizeAM(field, value));
}

export async function hashAllPresent(pii: AMInputs): Promise<AMInputs> {
  const out: AMInputs = {};
  await Promise.all(
    (Object.keys(pii) as AMField[]).map(async (k) => {
      const v = pii[k];
      if (v && v.trim()) out[k] = await hashAM(k, v);
    })
  );
  return out;
}
